import { Field, Int, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class ReferralOverviewDto {
  @Field()
  referralLink!: string

  @Field(t => Int)
  lifetimeReferrals!: number

  @Field(t => Int)
  availableCreditCents!: number

  /**
   * Earned but not spendable yet — still inside the 60-day window (or unapproved).
   */
  @Field(t => Int)
  pendingCreditCents!: number

  @Field(t => Int)
  lifetimeCreditCents!: number
}
